module.exports = __webpack_public_path__ + "img/export-list-img.16f834e8.svg";